var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('t-section',[_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h4',[_vm._v("Copyright © 2022. All rights reserved.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }